module.exports = __webpack_public_path__ + "img/icon_directory.f8fbb18c.png";